import { STypeGrpIds } from '../../../../../shared/utils/sTypeGrpIds';

export const bondSTypeGrpIds = [STypeGrpIds.OBLIGATIONS, STypeGrpIds.OBLIGATIONS_PERP, STypeGrpIds.OBLIGATIONS_SUB];

export const isBond = (sTypeGrpId: number): boolean => bondSTypeGrpIds.includes(sTypeGrpId);
